<div class="page">
  <div class="create-container">
    <app-config-title-bar></app-config-title-bar>
    <div [ngClass]="{ fullScreenEdit: fullScreenEdit }" class="container scrollbox">
      @if (!fullScreenEdit) {
        <div class="row">
          @if (svc) {
            <div class="configtitle">
              {{ svc.name + (svc.name.endsWith('Service') ? '' : ' Configuration') }}
            </div>
          }
          <div class="serviceFullName">
            @if (svc.fullName) {
              <div>
                <strong>Service ID:</strong>
                {{ svc.fullName }}
              </div>
            }
            @if (svc.fullName) {
              <img
                (click)="copy()"
                class="copyicon"
                src="/assets/svgs/copy.svg"
                style="width: 1.375rem; height: 1.1875rem"
                title="Click to copy full service name for use in configs and sdks [{{ svc.fullName }}]"
                />
            }
          </div>
        </div>
      }
      <div class="row">
        @for (cfg of configs; track cfg) {
          <div [hidden]="cfg.hidden" class="config-container">
            <div [ngClass]="{ 'col-lg-6': !fullScreenEdit, 'col-lg-12': fullScreenEdit }" class="col-sm-12">
              <app-config-edit-box
                (deleteConfig)="deleteConfig(cfg)"
                (expandToggled)="expandEditor(cfg)"
                (updateConfig)="update($event, cfg)"
                [configType]="configTypes[cfg.configTypeName]"
                [config]="cfg"
                [fullScreen]="fullScreenEdit"
                [schema]="cfg.cfg_schema"
              ></app-config-edit-box>
            </div>
          </div>
        }
      </div>
      @if (!fullScreenEdit) {
        <div class="addCustom col-lg-6 col-sm-12">
          <app-custom-config-box
            (addConfig)="addConfig($event)"
            [selectedConfigs]="configs"
          ></app-custom-config-box>
        </div>
      }
    </div>
  </div>
</div>
